// extracted by mini-css-extract-plugin
module.exports = {"extraLargeScreen":"1919px","largeScreen":"1599px","mediumScreen":"1279px","smallScreen":"767px"};